import React from 'react';
import AEABatchGrid from '../../ui/aea-batch-grid/aea-batch-grid';
import AEATitle from "@/components/ui/aea-title/aea-title";

export interface IPropsStep {
    columns: any,
    data: any,
    yearsColumn?: any,
    itemYears?: any,
    yearLabel?: string,
    index?: number,
    onSelectionChanged?:(e: any) => void,
}

const StepsPop: React.FC<IPropsStep> = ({columns, data, yearsColumn, itemYears, yearLabel, index, onSelectionChanged} : IPropsStep) => {
    
    return (
        <div style={{margin: '30px 0'}}>
            {(columns && data) && 
                <>
                    <AEABatchGrid 
                        dataSource={data} 
                        gridProps={{selection:{ mode: 'single' }}} 
                        columns={columns} readOnly={true} 
                        onSelectionChanged={onSelectionChanged} 
                    ></AEABatchGrid>
                    <div style={{marginTop: '30px'}}>
                        {!!itemYears?.length && 
                            <>
                            <AEATitle
                                id={yearLabel + index}
                                text={yearLabel}
                                tooltip={yearLabel}
                                placement={"auto"}
                            ></AEATitle>
                                <AEABatchGrid dataSource={itemYears} columns={yearsColumn} readOnly={true} ></AEABatchGrid>
                            </>
                        }
                    </div>
                </>
            }
        </div>
    )
}

export default StepsPop;